import { HaloJsBridge, SceneId, SceneName } from '@tencent/halo-jsbridge';

/**
 * 当前所在的媒体场景号，兼容旧版 JsBridge
 */
export const SCENE = SceneId.SCENE_TGB;

/**
 * 当前所在的媒体场景名
 * @description 所在场景未知时值为 null
 */
export const SCENE_NAME = SceneName.tgb;

// 保证在这个端实现了 halo-jsbridge 导出的所有接口
// 只是类型层面上的测试，这段代码没有副作用，在最终编译时也会被自动删除
// function haloJsBridgeEqualityCheck() { // eslint-disable-line @typescript-eslint/no-unused-vars
//   const stub: any = null;
//   const check = <T>(_: T) => null;     // eslint-disable-line @typescript-eslint/no-unused-vars
//   type MyJsBridge = typeof import ('.');
//   check<HaloJsBridge>(stub as MyJsBridge);
// }

export * from './app';
export * from './core';
export * from './data';
export * from './ui';
export * from './payment';
export * from './core/index';
